import { useEffect, useRef, useState } from "react";

/* Lazy-mounted, muted, looping background video with poster + overlay.
   Only loads the mp4 once the section approaches the viewport. */
export default function VideoBackground({
  src,
  poster,
  videoClassName = "",
  overlayClassName = "",
  className = "",
}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: "300px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      data-testid="video-background"
    >
      {inView && (
        <video
          className={`h-full w-full object-cover ${videoClassName}`}
          src={src}
          poster={poster}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
      )}
      {overlayClassName && <div className={`absolute inset-0 ${overlayClassName}`} />}
    </div>
  );
}
